export const DEFAULT_MUNICIPALITY_COMPARISON_LIMIT = 6;

export function resolveMunicipalityComparisonLimit(raw: string | undefined): number {
  if (raw === undefined || raw.trim() === '') {
    return DEFAULT_MUNICIPALITY_COMPARISON_LIMIT;
  }
  const parsed = Number.parseInt(raw.trim(), 10);
  if (!Number.isFinite(parsed) || parsed < 2) {
    return DEFAULT_MUNICIPALITY_COMPARISON_LIMIT;
  }
  return parsed;
}

export const MUNICIPALITY_COMPARISON_LIMIT = resolveMunicipalityComparisonLimit(
  import.meta.env.VITE_MUNICIPALITY_COMPARISON_LIMIT
);
